
// ROUTES
require('modules/event-tag/routes/event-tag');

// CONTROLLERS
require('modules/event-tag/controllers/event-tag');
require('modules/event-tag/controllers/list');
require('modules/event-tag/controllers/create');
require('modules/event-tag/controllers/edit');

// SERVICES
require('modules/event-tag/services/event-tag');
require('modules/event-tag/services/list');
require('modules/event-tag/services/create');
require('modules/event-tag/services/edit');
require('modules/event-tag/services/delete');


angular.module('unica_event_tag', [

	// ROUTES
	'unica_event_tag.event_tag_routes',

	// CONTROLLERS
	'unica_event_tag.event_tag_controllers',

	// SERVICES
	'unica_event_tag.event_tag_services'

]);


